<template>
    
    <div class="container py-5 mt-5">
        <div class="mt-5">
            <h3>مدرس های ناباکو</h3>
            <div class="row mt-5">
                <div class="col-md-4">
                    <div>
                        <img src="../../../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-start px-5">
                        <h3>Dr. Hossein Malekinejad</h3>
                        <h5>Chairman of the Board</h5>
                        <h5>Former Technology Director in Banking Technologies</h5>
                        <h5>PhD in Artificial Intelligence and Machine Learning</h5>
                        <h5>Developer of Predictive Systems in the Financial Industry</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <img src="../../../../public/img/miladTarverdi.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-start px-5">
                        <h3>Dr. Milad Tarvardi</h3>
                        <h5>Director of Solutions and Marketing at Nabaco</h5>
                        <h5>PhD in Digitalization from University of Tehran</h5>
                        <h5>PhD in Business Management – Digital Transformation</h5>
                        <h5>Instructor of MBA and Business Training Courses</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <img src="../../../../public/img/PoriaKhani.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-start px-5">
                        <h3>Engineer Pouria Khani</h3>
                        <h5>Instructor</h5>
                        <h5>Artificial Intelligence and Data Science Specialist</h5>
                        <h5>Expertise in Machine Learning and Deep Learning</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5 pt-5">
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/1.png" alt="">
                        <h6 class="mt-3 fw-bold">Understanding Artificial Intelligence and Its Applications in Finance</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 15 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/2.jpg" alt="">
                        <h6 class="mt-3 fw-bold">AI-Based Stock Selection Analysis in International Markets</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 15 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/3.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Risk Management with Artificial Intelligence</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 30 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/4.png" alt="">
                        <h6 class="mt-3 fw-bold">Algorithmic Trading and Investment Robots</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 30 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/5.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Market Prediction Using Machine Learning</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 30 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/6.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Sentiment Analysis and Decision-Making</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 30 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/7.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Considerations and Challenges</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Hossein Malekinejad</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 30 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/8.jpg" alt="">
                        <h6 class="mt-3 fw-bold">An Introduction to Digital Transformation in Banking</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Milad Tarvardi</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 45 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/9.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Enabling Digital Technologies in Banking</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Milad Tarvardi</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 60 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/10.jpg" alt="">
                        <h6 class="mt-3 fw-bold">Transformation in Payment Systems</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Milad Tarvardi</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 60 minutes</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../../assets/period-img/11.png" alt="">
                        <h6 class="mt-3 fw-bold">Challenges, Opportunities, and Roadmap for Banks</h6>
                        <div style="font-size: 15px;">Instructor: Dr. Milad Tarvardi</div>
                        <div style="font-size: 15px;">Format: In-person</div>
                        <div style="font-size: 15px;">Duration: 45 minutes</div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
    direction: ltr;
}
.card {
    border:none;
    box-shadow: 0px 0px 5px 0px #b6b6b6;
}
</style>